/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { isNone } from '@ember/utils';

import AnalyticsService from 'cio/services/analytics';
import SegmentModel from 'cio/models/segment';

interface SegmentSetupArgs {
  segment: SegmentModel;
  isSaving: boolean;
  saveSegment: () => unknown;
  resetSegment: () => unknown;
}

export default class SegmentSetup extends Component<SegmentSetupArgs> {
  @service analytics!: AnalyticsService;

  @tracked isShowingConditionBuilder = false;

  _nextSetupStep(segment: SegmentModel) {
    if (isNone(segment.type)) {
      return;
    } else {
      this.analytics.track('segment', 'type_chosen', { type: segment.type });

      if (segment.isManual) {
        return this.args.saveSegment();
      } else {
        return (this.isShowingConditionBuilder = true);
      }
    }
  }

  @action
  next() {
    this._nextSetupStep(this.args.segment);
  }

  constructor(owner: unknown, args: SegmentSetupArgs) {
    super(owner, args);
    this._nextSetupStep(args.segment);
  }
}
